module.exports = __webpack_public_path__ + "media/assets/img/products/studio_manual-not-selected-502cb35f3e37fb6ecf176e5000df6f81.svg";